<template>
  <div class="addUserCss1">
    <div class="addUserCss3">
      <InputText :inputObject="inputObject" v-for="inputObject in inputArray" :key="inputObject.name" :ref="inputObject.ref"></InputText>
      <Dropdown :dropdownObject="dropdownObject"></Dropdown>
      <div style="display: inline-block;">
        <div class="DIV2">
          类型：
        </div>
        <div class="DIV3">
          <el-select v-model="checked" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <SwitchState :switchObject="switchObject"></SwitchState>
    </div>
    <div class="addUserCss2">
      <Buttom :buttomObject="scbuttomObject" v-show="isUpdata"  @getSaveUser="createZjm"></Buttom>
      <Buttom :buttomObject="buttomObject" @getSaveUser="getSaveUserClick"></Buttom>
      <Buttom :buttomObject="callBackObject" v-show="isCallBack"  @getSaveUser="callBack"></Buttom>
    </div>
  </div>
</template>

<script>
  import Zjm from '@/assets/zjm.js'
  import Pinyin from '@/assets/Convert_Pinyin.js'
  import InputText from '@/components/Input/index.vue'
  import Buttom from '@/components/Buttom/index.vue'
  import Dropdown from '@/components/Dropdown/index.vue'
  import SwitchState from '@/components/SwitchState/index.vue'
  export default {
    name: 'addUser',
    data(){
      return {
        options: [
          {
            label: 'B2B',
            value: 1,
          },
          {
            label: '新零售',
            value: 2,
          },
          {
            label: '供应商',
            value: 3,
          }
        ],
        inputArray:[
          {
            "value":"",
            "ref":"customerName",
            "type":"text",
            "placeholder":"请输入客户名称（全称）",
            "clearable":true,
            "maxlength":50,
            "class":"inputCss",
            "label":"名称：",
            "isMustInput":true,
            "dataForm":false
          },
          {
            "value":"",
            "ref":"dbUserName",
            "type":"text",
            "placeholder":"请输入数据库账号",
            "clearable":true,
            "maxlength":50,
            "class":"inputCss",
            "label":"数据库账号：",
            "isMustInput":true,
            "dataForm":false
          },
          {
            "value":"",
            "ref":"dbPwd",
            "type":"text",
            "placeholder":"请输入数据库密码",
            "clearable":true,
            "maxlength":50,
            "class":"inputCss",
            "label":"数据库密码：",
            "isMustInput":true,
            "dataForm":false
          },
          {
            "value":"",
            "ref":"ip",
            "type":"text",
            "placeholder":"请输入服务器ip",
            "clearable":true,
            "maxlength":50,
            "class":"inputCss",
            "label":"服务器ip：",
            "isMustInput":true,
            "dataForm":false
          },
          {
            "value":"",
            "ref":"dbName",
            "type":"text",
            "placeholder":"请输入数据库名称",
            "clearable":true,
            "maxlength":50,
            "class":"inputCss",
            "label":"数据库名称：",
            "isMustInput":true,
            "dataForm":false
          },
          {
            "value":"",
            "ref":"dbPort",
            "type":"text",
            "placeholder":"请输入数据库端口",
            "clearable":true,
            "maxlength":50,
            "class":"inputCss",
            "label":"数据库端口：",
            "isMustInput":true,
            "dataForm":false
          },
          {
            "value":"",
            "ref":"identification",
            "type":"text",
            "placeholder":"标识必须唯一，请用客户首字母拼接，创建后不可修改",
            "clearable":true,
            "maxlength":10,
            "class":"inputCss",
            "label":"客户标识：",
            "isMustInput":true,
            "dataForm":false
          },
          {
            "value":"",
            "ref":"jkUrl",
            "type":"text",
            "placeholder":"http 或 https://域名/",
            "clearable":true,
            "maxlength":50,
            "class":"inputCss",
            "label":"监测链接：",
            "isMustInput":false,
            "dataForm":false
          }
        ],
        dropdownObject:{
          dropdownList:[],
          isMustInput:true,
          dropdownTitle:"请选择",
          label:"客户分类："
        },
        switchObject:{
          isMustInput:false,
          label:"监测开关：",
          isOpneClose:false
        },
        buttomObject:{
          type:"primary",
          round:false,
          buttomEventName:"getSaveUser",
          icon:"",
          size:"",
          label:"保存",
          plain:false
        },
        scbuttomObject:{
          type:"primary",
          round:false,
          buttomEventName:"getSaveUser",
          icon:"",
          size:"",
          label:"生成标识",
          plain:true
        },
        callBackObject:{
          type:"primary",
          round:false,
          buttomEventName:"getSaveUser",
          icon:"",
          size:"",
          label:"返回",
          plain:true
        },
        userInfo_id:"",
        isUpdata:true,
        isCallBack:true,
        checked:1
      }
    },
    components: {
      InputText,
      Buttom,
      Dropdown,
      SwitchState
    },
    created(){
      //获取传入的参数
      var query = this.$route.query;
      this.userInfo_id = query.userId;
    },
    methods:{
      createZjm(){
        var _n = this.$refs.customerName[0].inputObject.value;
        if(_n!=""){
          console.log(Pinyin.getCamelChars(_n));
          this.$refs.identification[0].inputObject.value = Pinyin.getCamelChars(_n)//Zjm(_n)[0]
        }else{
          this.$message({
            message: "请输入客户名称",
            type: 'warning'
          });
        }
      },
      callBack(){
        this.$router.push({path:'/userManage'});
      },
      getSaveUserClick:async function(parms) {
        var isFrom = true;
        for(var i=0;i<this.inputArray.length;i++){
          if(this.inputArray[i].isMustInput){
            if(this.inputArray[i].value == ""){
              this.$message({
                message: this.inputArray[i].placeholder,
                type: 'warning'
              });
              isFrom = false;
              break;
            }else{
            }
          }
        }
        if(isFrom){
          if(this.dropdownObject.dropdownTitle == "请选择"){
            this.$message({
              message: "请选择客户分类",
              type: 'warning'
            });
          }else{
            await this.$axios.post('/root/createUser',{
              'customerName':this.$refs.customerName[0].inputObject.value,
              'ip':this.$refs.ip[0].inputObject.value,
              'dbUserName':this.$refs.dbUserName[0].inputObject.value,
              'dbPwd':this.$refs.dbPwd[0].inputObject.value,
              'dbName':this.$refs.dbName[0].inputObject.value,
              'dbPort':this.$refs.dbPort[0].inputObject.value,
              'jkUrl':this.$refs.jkUrl[0].inputObject.value,
              'jkState':this.switchObject.isOpneClose,
              "identification":this.$refs.identification[0].inputObject.value,
              "label":this.dropdownObject.dropdownTitle,
              "id":this.userInfo_id,
              "isB2b":this.checked
            }).then((response,err) => {
              if(!err){
                response = response.data;
                if(response.code == "Fail"){
                  this.$message({
                    message: response.message,
                    type: 'warning'
                  });
                }else if(response.code == "Success"){
                  this.$message({
                    message: response.message,
                    type: 'success'
                  });
                }else if(response.code == "WhiteList"){
                  this.$message({
                    message: response.message,
                    type: 'warning'
                  });
                }else{
                  this.$message({
                    message: '登录异常',
                    type: 'warning'
                  });
                }
              }else{
                this.$message({
                  message: '登录异常',
                  type: 'warning'
                });
              }
            });
          }
        }
      },
      isAjax:async function(){
        await this.$axios.post('/data/addClass',{
          uid:this.userInfo_id
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownObject.dropdownList = response.data[0];
            var userInfo = response.data[1];
            this.$refs.customerName[0].inputObject.value = userInfo.customerName?userInfo.customerName:"";
            this.$refs.ip[0].inputObject.value = userInfo.ip?userInfo.ip:"";
            this.$refs.dbUserName[0].inputObject.value = userInfo.dbUserName?userInfo.dbUserName:"";
            this.$refs.dbPwd[0].inputObject.value = userInfo.dbPwd?userInfo.dbPwd:"";
            this.$refs.dbName[0].inputObject.value = userInfo.dbName?userInfo.dbName:"";
            this.$refs.dbPort[0].inputObject.value = userInfo.dbPort?userInfo.dbPort:"";
            this.$refs.jkUrl[0].inputObject.value = userInfo.monitorUrl?userInfo.monitorUrl:"";
            this.switchObject.isOpneClose = userInfo.monitorState?(userInfo.monitorState == 1?true:false):false;
            this.$refs.identification[0].inputObject.value = userInfo.identification?userInfo.identification:"";
            this.$refs.identification[0].inputObject.dataForm = true;
            this.dropdownObject.dropdownTitle = userInfo.class?userInfo.class:"请选择";
            console.log(typeof (userInfo.isB2b))
            console.log(userInfo.isB2b)
            this.checked = userInfo.isB2b
            if(userInfo.customerName){
              this.isUpdata = false;
              this.isCallBack = true;
            }else{
              this.isUpdata = true;
              this.isCallBack = false;
            }

          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    mounted(){
      this.isAjax();
    }
  }
</script>
<style scoped>
  @import '../../assets/common.css';
  body{
    padding: 0;
    margin: 0;
  }
  .addUserCss1{
    padding: 0;
    margin: 0;
    width: 1000px;
  }
  .addUserCss3{
    width: 1000px;
    height: 400px;
    text-align: left;
  }
  .addUserCss2{
    width: 100%;
    height: 60px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/addUser/index.vue